import { ActionMap } from 'action-typed';

export enum HubspotEvents {
    ADDED_PRODUCT_TO_CART = 'Hubspot.AddedProductToCart',
    ADDED_PRODUCT_TO_CART_ERROR = 'Hubspot.AddedProductToCart.Error',
    STARTED_CHECKOUT = 'Hubspot.StartedCheckout',
    STARTED_CHECKOUT_ERROR = 'Hubspot.StartedCheckout.Error',
    VIEW_PRODUCT = 'Hubspot.ViewProduct',
    VIEW_PRODUCT_ERROR = 'Hubspot.ViewProduct.Error',
}

export enum HubspotAnalyticEvents {
    ADDED_PRODUCT_TO_CART = 'added_to_cart',
    STARTED_CHECKOUT = 'started_checkout',
    VIEW_PRODUCT = 'viewed_product',
}

export enum HubspotTagManagerEvents {
    ADDED_PRODUCT_TO_CART = 'hubspot_added_to_cart',
    STARTED_CHECKOUT = 'hubspot_started_checkout',
    VIEW_PRODUCT = 'hubspot_viewed_product',
}

export type HubspotCart = {
    cart_id?: string;
    cart_url?: string;
    delivery_type?: string;
    items_count?: number;
    items_qty?: number;
    total_value?: number;
};
export type HubspotCustomer = {
    customer_email?: string;
    firstname?: string;
    is_guest?: boolean;
    lastname?: string;
};

export type HubspotProduct = {
    currency?: string;
    item_id?: string;
    labels?: string[];
    name?: string;
    price?: number;
    product_category?: string;
    product_image_url?: string;
    product_url?: string;
    sale_price?: number;
    save_price?: number;
    sku?: string;
    was_price?: number;
};

type HubspotGtmEvent<TagManagerEvent extends HubspotTagManagerEvents, HubspotEvent extends HubspotAnalyticEvents> = {
    cart_id?: string;
    event_name: HubspotEvent;
    event: TagManagerEvent;
    session_id?: string;
    timestamp?: string;
};

export type HubspotAddedProductToCartGtmEvent = HubspotGtmEvent<
    HubspotTagManagerEvents.ADDED_PRODUCT_TO_CART,
    HubspotAnalyticEvents.ADDED_PRODUCT_TO_CART
> &
    HubspotCustomer & {
        cart: HubspotCart;
        items: HubspotProduct[];
    };

export type HubspotStartedCheckoutGtmEvent = HubspotGtmEvent<
    HubspotTagManagerEvents.STARTED_CHECKOUT,
    HubspotAnalyticEvents.STARTED_CHECKOUT
> &
    HubspotCustomer & {
        cart: HubspotCart;
        checkout_id?: string;
        checkout_url?: string;
        items: HubspotProduct[];
    };

export type HubspotViewProductGtmEvent = HubspotGtmEvent<
    HubspotTagManagerEvents.VIEW_PRODUCT,
    HubspotAnalyticEvents.VIEW_PRODUCT
> &
    HubspotProduct &
    HubspotCustomer;

export type Messages = {
    [HubspotEvents.ADDED_PRODUCT_TO_CART]: HubspotAddedProductToCartGtmEvent;
    [HubspotEvents.STARTED_CHECKOUT]: HubspotStartedCheckoutGtmEvent;
    [HubspotEvents.VIEW_PRODUCT]: HubspotViewProductGtmEvent;
};

export type TypeMap = ActionMap<Messages>;
export type HubspotActions = TypeMap[keyof TypeMap];
